<template>
	<div>
		<div class="contentBigBox">
			<div class="details-title">
				<div>{{changeReportsList.FirstApproverName}}备选报告</div>
				<div></div>
			</div>
			<div class="selectSearch">
				<el-form ref="form" :model="GetCanChangableReportsParameter" class="qcFrom" :inline="true">
					<el-form-item label="检查项目">
						<el-input v-model="GetCanChangableReportsParameter.CheckintItem" class="name" placeholder="请输入检查项目" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="设备类型">
						<el-select v-model="GetCanChangableReportsParameter.modalityType" placeholder="请选择设备类型" size="mini" class="name">
							<el-option v-for="(item,index) in modalityTypeSelect" :key="index" :label="item.text" :value="item.sorts"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="search" round>查询</el-button></el-form-item>
				</el-form>
			</div>
			<el-row :gutter="30" v-loading="loading">
				<el-col :span='24'>
					<el-table class="qcTable haveFilterTable" ref="multipleTable" :data="GetCanChangableList.Reports" highlight-current-row v-loading="loading" >
						<el-table-column prop="AccNo" min-width="100" label="报告编号" show-overflow-tooltip></el-table-column>
						<el-table-column prop="ModalityType" column-key='ModalityType' min-width="100" label="设备类型"></el-table-column>
						<el-table-column prop="CheckingItems" min-width="120" label="检查项目" show-overflow-tooltip></el-table-column>
						<el-table-column prop="" label="操作" fixed='right' width="180">
							<template slot-scope="scope">
								<span class="tableOpe" @click="handleClick(scope.row)">查看详情</span>
								<span class="tableOpe marl10" @click="cancle(scope.row)">更换报告</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" v-anchor="1" :total="GetCanChangableList.TotalCount" :page-size='GetCanChangableReportsParameter.pageCount'
				 :current-page='GetCanChangableReportsParameter.pageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
		<el-dialog title="报告详情" :modal-append-to-body="false" :visible.sync="dialogVisible" width="50%">
			<div class="doctorPage" v-loading="loading">
				<div class="centerHome centerHomeActive">
					<el-row class="ccHomec">
						<el-col :span="24" class="doctorReport">
							<doctor-report />
						</el-col>
					</el-row>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialogVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="cancle(1)">确定更换</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import doctorReport from '@/components/doctorReport.vue'
	export default {
		data() {
			return {
				activeNames: ['1', '2'],
				active: 0,
				currentRow: null,
				height: 0,
				datas: {},
				thisOnly: true,
				dialogVisible:false,
				NewReportGuid:''
			};
		},
		components: {
			doctorReport,
		},
		computed: {
			...Vuex.mapState('managerPlanList', ['qcresultsList', 'GetCanChangableList','secondListFiltersType',
				 'taskListTitle', 'GetCanChangableReportsParameter','changeReportsList','ChangeReportsList'
			]),
			...Vuex.mapState('breadcrumb', ['selectRow','modalityTypeSelect','loading']),
		},
		activated() {	
			this.GetCanChangableReportsParameter.SamplingTaskGuid = this.changeReportsList.SamplingTaskGuid;
			this.GetCanChangableReportsParameter.ReportGuid = this.changeReportsList.ReportGuid;
			this.GetCanChangableReportsParameter.HospitalGuid = this.changeReportsList.HospitalGuid;
			if (this.changeReportsList.SubjectType == 4) {
				this.GetCanChangableReportsParameter.DoctorName = this.changeReportsList.ReportSubmitterName;
			}else if(this.changeReportsList.SubjectType == 3){
				this.GetCanChangableReportsParameter.DoctorName = this.changeReportsList.TechnictionName;
			}else{
				this.GetCanChangableReportsParameter.DoctorName = this.changeReportsList.FirstApproverName;
			}
			this.GetCanChangableReports(this.GetCanChangableReportsParameter);
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setqcresultsShow', 'setTootipType']),
			...Vuex.mapMutations('managerPlanList', ['setLoading', 'currentChangesSecond']),
			...Vuex.mapMutations('doctor', ['setDetailsParameter', 'setDetalLoading']),
			...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask', 'GetCanChangableReports','ChangeReports']),
			...Vuex.mapActions('doctor', ['GetReportInfo']),
			// 确定更换
			cancle(row){
				let _this = this;
				let data = {
					 "SamplingTaskGuid": this.changeReportsList.SamplingTaskGuid,
					  "OldReportGuid": this.changeReportsList.ReportGuid,
					  "NewReportGuid": this.NewReportGuid
				}
				if (row == 1) {
					data.NewReportGuid = this.NewReportGuid;
					_this.changeReportsfun(data);
				}else{
					data.NewReportGuid = row.ReportGuid;
					_this.$confirm('是否确定更换报告？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						_this.changeReportsfun(data);
					}).catch((err) => {
						_this.$message({
							type: 'info',
							message: '已取消撤回'
						});
					});
				}
			},
			changeReportsfun(data){
				this.ChangeReports(data).then(res=>{
					if (res.data.StatusCode == 200) {
						this.dialogVisible = false;
						ELEMENT.Message.success("更换成功")
						this.$router.push("/home/manager/task/reviewReportList");
					}
				});
			},
			search(){
				this.GetCanChangableReportsParameter.pageIndex = 1;
				this.GetCanChangableReports(this.GetCanChangableReportsParameter);
			},
			// 跳转至详情页
			handleClick(val) {
				this.NewReportGuid = val.ReportGuid;
				this.qcresultsList.changeValue({
					Name:val.Name,
					expertUserId:val.ExpertUserId,
					ReportGuid:this.changeReportsList.ReportGuid,
					SamplingTaskGuid:this.changeReportsList.SamplingTaskGuid
				})
				this.setDetailsParameter({
					reportGuid: this.qcresultsList.ReportGuid,
					samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
					ExpertUserGuid: this.qcresultsList.expertUserId
				})
				this.GetQCResultsByTask({
					samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
					reportGuid: this.qcresultsList.ReportGuid
				})
				this.GetReportInfo({reportGuid:val.ReportGuid})
				this.dialogVisible = true;
				// this.$router.push("/home/manager/scoring");
				// document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}
			},
			//分页
			currentChange(val) {
				this.GetCanChangableReportsParameter.pageIndex = val;
				this.GetCanChangableReports(this.GetCanChangableReportsParameter);
			},
		}
	}
</script>
<style scoped>
	.contentBigBox {
		padding-top: 36px;
	}

	.haveFilterTable>>>.el-icon-arrow-down:before {
		content: "\e791" !important;
	}
	.el-dialog__wrapper >>> .el-dialog{
		height: 85%;
	}
	.el-dialog__wrapper >>> .el-dialog .el-dialog__body{
		color: #ffffff;
	}
</style>
